import * as React from 'react';
import { Box, Tabs, Tab, Typography, Paper } from '@mui/material';
import EngineeringIcon from '@mui/icons-material/Engineering';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import TimelineIcon from '@mui/icons-material/Timeline';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import ConstructionIcon from '@mui/icons-material/Construction';

import { TechnicalNewInstallation } from './TechnicalNewInstallation';
import { TechnicalComplaint } from './TechnicalComplaint';
import { TechnicalRemovalTransfer } from './TechnicalRemovalTransfer';
import { TechnicalRepairReplacement } from './TechnicalRepairReplacement';

const TABS = [
  { label: 'New Installation',     icon: <BuildCircleIcon fontSize="small" />,   component: TechnicalNewInstallation },
  { label: 'Complaint',            icon: <TimelineIcon fontSize="small" />,       component: TechnicalComplaint },
  { label: 'Removal / Transfer',   icon: <CompareArrowsIcon fontSize="small" />, component: TechnicalRemovalTransfer },
  { label: 'Repair / Replacement', icon: <ConstructionIcon fontSize="small" />,  component: TechnicalRepairReplacement },
];

function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default function TechnicalPage() {
  const [activeTab, setActiveTab] = React.useState(0);

  return (
    <Box sx={{ width: '100%', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Box sx={{ px: 3, pt: 3, pb: 1, display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <EngineeringIcon sx={{ fontSize: 32, color: 'primary.main' }} />
        <Typography variant="h5" fontWeight={600}>Technical</Typography>
      </Box>

      <Paper elevation={0} sx={{ mx: 3, borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
        <Tabs
          value={activeTab}
          onChange={(_, v) => setActiveTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            px: 1,
            '& .MuiTab-root': { minHeight: 52, textTransform: 'none', fontWeight: 500, fontSize: '0.9rem', gap: 0.75 },
            '& .Mui-selected': { fontWeight: 700 },
          }}
        >
          {TABS.map((tab, i) => (
            <Tab key={i} label={tab.label} icon={tab.icon} iconPosition="start" />
          ))}
        </Tabs>
      </Paper>

      {TABS.map((tab, i) => (
        <TabPanel key={i} value={activeTab} index={i}>
          <tab.component />
        </TabPanel>
      ))}
    </Box>
  );
}
